// services/apiLogService.js
import api from "./api";

export const getAllLogs = async () => {
  try {
    const response = await api.get("/api-logs/");
    return response.data.results;
  } catch (error) {
    console.error("Error fetching logs:", error);
    throw error;
  }
};

export const getLogDetails = async (id) => {
  try {
    const response = await api.get(`/api-logs/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching log details for id ${id}:`, error);
    throw error;
  }
};

export const getLogsWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  startDate = "",
  endDate = "",
  ordering = "-added_on",
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    const response = await api.get("/api-logs/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching logs with pagination:", error);
    throw error;
  }
};

// Optional: Add additional utility functions

export const getLogStats = async (timeframe = "day") => {
  try {
    const response = await api.get("/api-logs/stats/", {
      params: { timeframe },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching log statistics:", error);
    throw error;
  }
};

export const getLogsByEndpoint = async (endpoint) => {
  try {
    const response = await api.get("/api-logs/", {
      params: {
        endpoint,
        ordering: "-added_on",
      },
    });
    return response.data.results;
  } catch (error) {
    console.error(`Error fetching logs for endpoint ${endpoint}:`, error);
    throw error;
  }
};

export const getLogsByStatusCode = async (statusCode) => {
  try {
    const response = await api.get("/api-logs/", {
      params: {
        status_code: statusCode,
        ordering: "-added_on",
      },
    });
    return response.data.results;
  } catch (error) {
    console.error(`Error fetching logs for status code ${statusCode}:`, error);
    throw error;
  }
};

// Optional: Add export functionality
export const exportLogs = async (format = "csv", filters = {}) => {
  try {
    const response = await api.get("/api-logs/export/", {
      params: {
        format,
        ...filters,
      },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting logs:", error);
    throw error;
  }
};
